import React from "react";

function Support(){

    
    var longfooter = document.querySelector('.support-brief-container');
    if(document.cookie.indexOf('supportprogramme_thankyou=1') !== -1){
      if(longfooter){
        longfooter.style.display="none";
      }
    }
      
    function sendEvent(event) {
        if (window.digitalData) {
          window.digitalData.events.push(event);
        }
    };
    function detectDevice(){
        var minDesktopWidth = 841;
        return document.documentElement.clientWidth < minDesktopWidth ? "mobile" : "desktop";
    }
    
    window.digitalData = window.digitalData || {
        page: {
          pageInfo: {
            pageID: "interactive",
            pageName: "Support Stuff's Journalism",
            sysEnv: detectDevice(),
            variant: "1",
            version: "1",
            publisher: "",
            articleID: "",
            headline: "",
            author: "",
            source: "",
            lastPublishedTime: ""
          },
          category: {
            pageType: "interactive",
            primaryCategory: "interactive"
          },
          ads: {
            environment: "prod",
            exclusions: "",
            sections: []
          }
        },
        user: [{
          profile: [{
            profileInfo: {
              uid: ""
            }
          }],
          segment: {}
        }],
        events: []
    };

    window.addEventListener("message", (event) => {
    if (event.data && event.data.eventName === "payment_successful") {
    var oneDayInSec = 86400;
    var exclusionPeriod =
    event.data.payload.frequency === "one-time"
        ? 60 * oneDayInSec
        : 365 * oneDayInSec;
    document.cookie =
    "supportprogramme_thankyou=1; max-age=" +
    exclusionPeriod +
    "; domain=.stuff.co.nz;path=/;";
    sendEvent({
    event: "donation.successful",
    "donation.amount": event.data.payload.amount,
    "donation.frequency": event.data.payload.frequency,
    });
    }
    });

    return (
      <div className="support-brief-container--wrapper">
      <div className="supporter-wrapper">
      <div className="supporter-wrapper--top">
          <p><b>This story matters to Aotearoa</b></p>
          <p>That's why we wrote it, and why you've taken the time to read it.</p>
          <p>At Stuff we report what's right, not what's convenient. We're 100% Kiwi-owned and fiercely independent.</p>
          <p>If getting news that's free from political influence, unchecked rumours and clickbait is important to you, <b>please support Stuff today.</b></p>
      </div>
      <div className="supporter-wrapper--bottom" >
          <span>Support Stuff’s journalism today</span>
          <a
          onClick={sendEvent({ event: 'article.become.a.supporter' })}
          data-pp-page="pwyw"
          data-pp-metadata="$pay-what-you-want-campaign-page-version-1.1"
          href="https://dashboard.presspatron.com/donations/new?frame=1&t=TJu26zZFBKa635NQ13AZRn8S?utm_source=stuff&utm_medium=widget-platform-asset&utm_campaign=supporter-program&utm_content=whole-truth-temaramatanga">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 18H24.34L13.16 29.18L16 32L32 16L16 0L13.18 2.82L24.34 14H0V18Z"/>
              </svg>
          </a>
      </div>
      </div>
        </div>
    )
}

export default Support;
